'use client';

import {useTranslations, useLocale} from 'next-intl';
import Button from '../ui/Button';

export default function CTASection() {
  const t = useTranslations('home');
  const locale = useLocale();

  return (
    <section className="relative overflow-hidden mt-8">
      <div className="absolute inset-0 bg-[url('/images/utss/article_a.jpg')] bg-cover bg-center" />
      <div className="absolute inset-0 bg-secondary/90" />
      {/* Rose SVG filigrane */}
      <img
        src="/images/utss/rose.svg"
        alt=""
        aria-hidden="true"
        className="absolute right-8 lg:right-20 top-1/2 -translate-y-1/2 w-[200px] h-[200px] opacity-10 pointer-events-none select-none"
      />

      <div className="relative max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 py-20 text-center">
        <h2 className="text-3xl sm:text-4xl font-bold text-white mb-4">
          {t('campaign_title')}
        </h2>
        <p className="text-white/80 text-lg mb-8 max-w-2xl mx-auto">
          {locale === 'ar'
            ? 'ساهم في دعم المشاريع التضامنية عبر كامل تراب الجمهورية'
            : locale === 'en'
            ? 'Contribute to solidarity projects across the entire Republic of Tunisia'
            : 'Contribuez aux projets solidaires a travers tout le territoire tunisien'}
        </p>
        <div className="flex flex-wrap justify-center gap-4">
          <Button href={`/${locale}/don`} variant="accent" size="lg">
            {t('hero_donate')}
          </Button>
          <Button href={`/${locale}/projets`} variant="outline" size="lg" className="!border-white !text-white hover:!bg-white hover:!text-primary">
            {t('hero_cta')}
          </Button>
        </div>
      </div>
    </section>
  );
}
